<template>
    <el-table-column label="核对信息" min-width="350" align="center">
        <template slot-scope="scope">
            <div style="text-align: left">
                <div>
                    <span class="fixedTitle">标品类型：</span>
                    {{ scope.row.standard_product_type == -1 ? '未录入' : scope.row.standard_product_type }}
                </div>

                <div>
                    <span class="fixedTitle">选品原则：</span>
                    {{ scope.row.selection_principle }}
                </div>

                <div>
                    <span class="fixedTitle">fba费用核对：</span>
                    <span
                        :class="{'redClass': scope.row.check_fba_charge == -1, 'greenClass': scope.row.check_fba_charge == 1}">
                                {{
                            scope.row.check_fba_charge == 1 ? '已核对' : scope.row.check_fba_charge == 0 ? '待核对' : '核对有误'
                        }}
                            </span>

                    <el-button
                        style="float:right;margin-left:6px;"
                        size="mini"
                        plain
                        @click="showMessage(scope.row.check_fba_charge_err_msg)"
                        v-show="scope.row.check_fba_charge == -1"
                    >查看</el-button>
                </div>

                <div>
                    <span class="fixedTitle">是否主卖：</span>
                    {{ scope.row.is_main_seller == 1 ? '是' : '否' }}
                </div>

                <div>
                    <span class="fixedTitle">包装核对：</span>
                    <span
                        :class="{'redClass': scope.row.check_packing == 0, 'greenClass': scope.row.check_packing == 1}">
                                {{ scope.row.check_packing == 1 ? '已核对' : '未核对' }}
                            </span>
                </div>

                <div>
                    <span class="fixedTitle">价格核对：</span>
                    <span>{{
                            scope.row.is_market_lowest_price === 1 ? '是' : (scope.row.is_market_lowest_price === 0 ? '否'
                                : '')
                        }}
                            </span>
                </div>

                <div>
                    <span class="fixedTitle">vine情况：</span>
                    <span
                        :class="{'greenClass': ['完成', '老品'].includes(scope.row.vine_status),  'redClass': !['完成', '老品'].includes(scope.row.vine_status)}">
                                {{ scope.row.vine_status }}
                    </span>
                </div>

                <div>
                    <span class="fixedTitle">vine店铺：</span>
                    {{ scope.row.vine_shop }}
                </div>

                <div>
                    <span class="fixedTitle">是否季节性：</span>
                    {{ scope.row.is_seasonality == 1 ? '是' : '否' }}
                </div>

                <div>
                    <span class="fixedTitle">季节：</span>
                    {{ scope.row.season }}
                </div>
                </div>


        </template>
    </el-table-column>

</template>

<script>
 export default {
    name: "checkInfo",
    methods: {
        showMessage(data) {
            this.$notify.info({
                title: '错误信息',
                message: data
            });
        }
    }
}
</script>

<style scoped lang="scss">
.fixedTitle {
    font-size: 13px;
    font-weight: 600;
    width: 90px;
    display: inline-block;
    text-align: left;
}

.redClass {
    color: red;
    font-weight: bold;
}

.greenClass {
    color: green;
    font-weight: bold;
}

</style>
